import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettingsService, ArrayResponse, BaseRestService, encodeBase64, saveAs, SendBackResult} from '../../shared';
import {TriggerInvoices} from '../models/invoices';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InvoicesService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'InvoicesService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }
// tslint:disable-next-line:no-any
  numberAdd(validation: object): any {
    return this.put(`/Billings/InvoiceCounters`, validation );
  }
  // tslint:disable-next-line:no-any
  getNumber(): any {
    return this.get(`/Billings/InvoiceCounters` );
  }

  // tslint:disable-next-line:no-any
  trigger(triggerInvoices: TriggerInvoices): any {
      return this.post(`/Billing/CreateCalculationTask`, triggerInvoices );
  }
  // tslint:disable-next-line:no-any
  validation(validation: object): any {
    return this.post(`/Billing/CreateValidationTask`, validation );
  }

  // tslint:disable-next-line:no-any
  clear(taskId: object): any {
    return this.post(`/Billing/Task/${taskId}/Clear`, '' );
  }
  // tslint:disable-next-line:no-any
  reprocessTask(taskId: object): any {
    return this.post(`/Billing/Task/${taskId}/Reprocess`, '' );
  }
  // tslint:disable-next-line:no-any
  summaryList(companyUuid: string): Observable<SendBackResult<ArrayResponse<any>>>  {
    // tslint:disable-next-line:no-any
    return this.get<ArrayResponse<any>>(`/Company/${companyUuid}/Invoices/Summary`);
  }

  // tslint:disable-next-line:no-any
  validationFiles(validationTask: string): any {
     this.getExl(validationTask).subscribe(
       (response) => {
         saveAs(`data:text/csv;base64,${encodeBase64('sep=,\r\n' + response)}`, 'invoices.csv')
         });
  }


  // tslint:disable-next-line:typedef
  getExl(validationTask: string) {
    return this.getFile(`/Billing/ValidationFile/${validationTask}`);
  }
  // tslint:disable-next-line:no-any
  salesForceFiles(date: string): any {
      this.getSaleForce(date).subscribe(
        (response) => {
          saveAs(`data:text/csv;base64,${encodeBase64('sep=,\r\n' + response)}`, date + '_SalesForce_Export.csv')
        });
    }

  // tslint:disable-next-line:typedef
  getSaleForce(date: string) {
    return this.getFile(`/Billings/ExportSalesforce/file?date=${date}`);
  }
}
